import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import classNames from "classnames";

import { TOAST_TYPE } from "lib/constants";

const mapStateToProps = (state) => ({
    toast: state.ws.toast,
});

class ToastMessages extends React.PureComponent {
    static propTypes = {
        toast: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number.isRequired,
                content: PropTypes.node,
            }),
        ).isRequired,
    };

    render() {
        const toasts = this.props.toast.map(({ type, content }, idx) => {
            const className = classNames({
                "toast--info": type === TOAST_TYPE.INFO,
                "toast--warning": type === TOAST_TYPE.WARNING,
                "toast--error": type === TOAST_TYPE.ERROR,
            });

            return (
                <CSSTransition
                    key={idx}
                    mountOnEnter
                    unmountOnExit
                    timeout={200}
                    classNames="fadeout"
                >
                    <span className={className}>{content}</span>
                </CSSTransition>
            );
        });

        return <TransitionGroup className="toast-message">{toasts}</TransitionGroup>;
    }
}

export default connect(mapStateToProps)(ToastMessages);
